import { useNavigate, useParams } from "react-router-dom";
import { JOB_LIST_ROUTE, JOB_UPDATE_ROUTE } from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import * as Yup from "yup";
import { segmentTemplates } from "./template";
import { useFormik } from "formik";
import EditableView from "../PageView/EditableView";
import { X } from "lucide-react";
import { showNotification } from "Common/utils/Notification";
import { useEffect, useState } from "react";
import { TailSpin } from "react-loader-spinner";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import { ToastContainer } from "react-toastify";
import BreadCrumb from "Common/BreadCrumb";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import _, { values } from "lodash";
import ReactSelect from "Common/Components/ReactSelect/ReactSelect";
import CustomInput from "Common/Components/InputFields/CustomInput";

import CustomTextArea from "Common/Components/InputFields/CustomTextArea";

import MetaData from "Common/MetaData";
import moment from "moment";
import CustomDateInput from "Common/Components/InputFields/CustomDateInput";

const Updatejob = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [formData, setFormData] = useState<any>({ released_at: "" });
  const [link, setLink] = useState<any>("");
  const [locationList, setLocationList] = useState<any>([]);
  const [showApprove, setShowApprove] = useState<any>(false);
  const [version, setVersion] = useState<any>();
  const [segmentVersion, setSegmentVersion] = useState<any>();
  const [divisionList, setDivisionList] = useState<any>([]);
  const [experienceList, setExperienceList] = useState<any>([]);
  const [staticExperience, setStaticExperience] = useState<any>();
  const [staticLocation, setStaticLocation] = useState<any>();
  const [staticDivision, setStaticDivision] = useState<any>();
  const [imageLink, setImageLink] = useState<any>();
  const [isLoading, setIsLoading] = useState<any>();
  const [selectedSegment, setSelectedSegment] = useState("");
  const [content, setContent] = useState<any>();
  const [jobData, setJobData] = useState<any>();
  const [collapse, setCollapse] = useState([]);
  const [pageView, setPageView] = useState<any>();
  const [segmentData, setSegmentData] = useState([]);
  const [segmentList, setSegmentList] = useState([]);
  const [loader, setLoader] = useState<any>(false);
  const [imageData, setImageData] = useState<any>("");
  const [metaEdit, setMetaEdit] = useState<any>({
    url: "",
    page_title: "",
    meta_description: "",
    meta_keyword: "",
    canonical_url: "",
  });
  const [errors, setErrors] = useState<any>();
  const [showMeta, setShowMeta] = useState<any>(false);
  const toggleMeta = () => setShowMeta(!showMeta);
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please Select Image", "error");
      }
    }
  }, [imageData]);
  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  const userHasPermissionToEditPage = () => {
    return permission?.permissions?.includes("job:edit");
  };

  const userHasPermissionToApprovePage = () => {
    return permission?.permissions?.includes("job:verify");
  };

  const userHasPermissionToPublishPage = () => {
    return permission?.permissions?.includes("job:publish");
  };

  useEffect(() => {
    const fetchDataByCode = async (code: string) => {
      const res = await callApi(`v1/content/code/${code}`, "get", {});
      if (res.status === "Success") {
        return res.data.content?.params || [];
      }
      return [];
    };
    const fetchAllData = async () => {
      let results = await Promise.all([
        fetchDataByCode("job-division"),
        fetchDataByCode("job-experience"),
        fetchDataByCode("job-location"),
      ]);
      if (results.length > 0) {
        setExperienceList(results[1]);
        setLocationList(results[2]);
        setDivisionList(results[0]);
      }
    };

    fetchAllData();
  }, []);

  const handleChangeJob = (name, value) => {
    if (name === "experience") {
      setStaticExperience(value);
    } else if (name === "division") {
      setStaticDivision(value);
    } else if (name === "location") {
      setStaticLocation(value);
    }
  };

  useEffect(() => {
    async function fetchannouncement(id: any) {
      try {
        const res = await callApi(`v1/job/${id}`, "get", {});
        if (res && res?.status === "Success") {
          setImageLink(res.data.job);
          setJobData(res.data.job);
          setContent(res.data.job.text);
          setMetaEdit(res.data.job);
          setFormData({
            released_at: res.data.job?.released_at,
          });
          setStaticDivision({
            label: res.data.job.division,
            value: res.data.job.division,
          });
          setStaticExperience({
            label: res.data.job.experience,
            value: res.data.job.experience,
          });
          setLink(res.data.job.link);
          setStaticLocation({
            label: res.data.job.location,
            value: res.data.job.location,
          });
        }
      } catch (e) {
        showNotification("something went wrong", "error");
      }
    }
    if (id) {
      fetchannouncement(id);
    }
  }, [id]);

  useEffect(() => {
    fetchPageView();
    if (id) fetchVersionList(id);
    if (id) fetchSegmentVersion(id);
  }, [id, loader]);

  const fetchPageView = async () => {
    try {
      // Fetch editable view list
      const localData = await callApi("v1/editableview/list", "post", {});

      if (localData?.status !== "Success") return;

      const segmentKeys = localData.data.editableviewList.map(
        (item) => item.slug
      );

      // Fetch job details first
      const jobRes = await callApi(`v1/job/${id}`, "get");

      if (jobRes?.status !== "Success") return;

      // Fetch detailed info using `res.data.url`
      const detailedInfoRes = await callApi(
        `v1/job/${jobRes.data.job.url}/detailed-info`,
        "post",
        {}
      );

      if (detailedInfoRes?.status !== "Success") return;

      const page = detailedInfoRes.data.job;
      const newSegmentData: any[] = []; //

      segmentKeys.forEach((segmentKey) => {
        if (page?.[segmentKey]?.length) {
          page[segmentKey].forEach((pageSegment) => {
            newSegmentData[pageSegment._id] = {
              data: pageSegment,
              segment_type: segmentKey,
            };
          });
        }
      });

      // Update state variables
      setSegmentList(
        segmentKeys.filter(
          (item) =>
            item === "code_segments" ||
            item === "description_segments" ||
            item === "banner_segments"
        )
      );
      setPageView(page);
      setSegmentData(newSegmentData);
    } catch (error) {
      showNotification("Error occurred", "error");
    }
  };

  const handleSegmentChange = (e) => {
    setSelectedSegment(e.target.value);
  };

  const handleshowSagment = (index) => {
    if (collapse.some((item) => item === index)) {
      setCollapse(collapse.filter((item) => item !== index));
    } else {
      let array = [...collapse];
      array.push(index);
      setCollapse(array);
    }
  };

  const handleApprove = async () => {
    if (!jobData) {
      showNotification("Page data is missing. Please try again.", "error");
      return;
    }
    if (jobData?.url) {
      try {
        const response = await callApi(
          `v1/job/url/${jobData?.url}/approve`,
          "get"
        );
        if (response?.status === "Success") {
          setLoader(!loader);
          showNotification("Page approved successfully", "success");

          setShowApprove(true);
        }
      } catch (error) {
        showNotification(
          "An error occurred while publishing the page. Please try again.",
          "error"
        );
      }
    }
  };

  const handlePublish = async (url: any) => {
    try {
      const res = await callApi(`v1/job/${url}/publish-job`, "get", {});
      if (res && res?.status === "Success") {
        showNotification("Published successfully", "success");
        fetchPageView();
        setLoader(!loader);
        setShowApprove(false);
        window.location.reload();
      }
    } catch (e) {
      showNotification(
        e.response.data.data.message || "Error occured",
        "error"
      );
    }
  };

const handleMetaChange = (keyName, keyValue) => {
  setMetaEdit((prev) => ({
    ...prev,
    [`updated_${keyName}`]: keyValue,
    is_meta_edited: true, 
  }));
  setErrors((prev) => ({
    ...prev,
    [`updated_${keyName}`]: "",
  }));
};

  // const handleValidate = (data: any) => {
  //   let isValid = true;
  //   let error: { [index: string]: any } = {};
  //   if (!data?.url || data?.url === "") {
  //     isValid = false;
  //     error["url"] = "Please enter url";
  //   }
  //   if (!data?.canonical_url || data?.canonical_url === "") {
  //     isValid = false;
  //     error["canonical_url"] = "Please enter canonical url";
  //   }
  //   if (!data?.page_title || data?.page_title === "") {
  //     isValid = false;
  //     error["page_title"] = "Please enter page title";
  //   }
  //   if (!data?.meta_description || data?.meta_description === "") {
  //     isValid = false;
  //     error["meta_description"] = "Please enter meta description";
  //   }
  //   if (!data?.meta_keyword || data?.meta_keyword === "") {
  //     isValid = false;
  //     error["meta_keyword"] = "Please enter meta keyword";
  //   }
  //   return {
  //     isValid,
  //     error,
  //   };
  // };
  const handleMetaData = async () => {
    // let check = handleValidate(metaEdit);
    // if (check.isValid) {
    try {
      const res = await callApi(`v1/job/${jobData?.url}/update-job`, "post", {
        ...metaEdit,
      });
      if (res && res?.status === "Success") {
        showNotification("Updated successfully", "success");
        toggleMeta();
      }
    } catch (e) {
      showNotification(
        e.response.data.data.message || "Error occured",
        "error"
      );
    }
    // } else {
    //   setErrors(check.error);
    // }
  };
  // function handleSegment(segmentData) {
  //   switch (segmentData.segment_type) {
  //     case "home_banner_segments":
  //       break;

  //     case "banner_segments":
  //       break;
  //     default:
  //       console.log("Unknown segment type:", segmentData.segment_type);
  //   }
  // }

  const handleAddSegment = async () => {
    if (!selectedSegment) {
      alert("Please select a segment");
      return;
    }

    const segmentDataToAdd = segmentTemplates[selectedSegment];

    // handleSegment({
    //   segment_type: selectedSegment,
    //   segment: segmentDataToAdd.segment,
    // });
    try {
      const res = await callApi(
        `v1/job/${id}/add-segment`,
        "post",
        segmentDataToAdd
      );
      fetchPageView();
      if (res?.status === "Success") {
        showNotification("Segment added successfully");
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  //delete
  const handleDelete = async (Id, type) => {
    try {
      const bannerSegmentResult = await callApi(
        `v1/job/${id}/segment/${Id}/remove-segment`,
        "post",
        { segment_type: type }
      );

      if (bannerSegmentResult.status === "Success") {
        setLoader(!loader);
        showNotification(" Removed segment successfully", "success");
      } else {
      }
    } catch (error) {
      showNotification("Error removing segment", "error");
    }
  };
  // validation
  const validation: any = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      name: (jobData && jobData.name) || "",
      description: (jobData && jobData.description) || "",

      // link: (jobData && jobData.link) || "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please Enter Name"),
      // description: Yup.string().required("Please Enter Description"),

      // link: Yup.string().required("Please Enter Link"),
    }),

    onSubmit: async (values) => {
      const updateData = {
        _id: jobData ? jobData._id : 0,
        ...values,
      };

      // update user
      try {
        setIsLoading(true);
        const res = await callApi(`v1/job/${jobData?.url}/update-job`, "post", {
          ...values,
          location: staticLocation?.value,
          division: staticDivision?.value,
          experience: staticExperience?.value,
          link: link,
          url: jobData?.url,
          ...formData,
        });
        setIsLoading(false);
        if (res && res?.status === "Success") {
          showNotification("Updated successfully", "success");
          setIsLoading(true);
          setTimeout(() => {
            navigate(JOB_LIST_ROUTE);
            setIsLoading(false);
          }, 800);
        }
      } catch (e) {
        showNotification("Something went wrong", "error");
      } finally {
        setIsLoading(false);
      }
    },
  });

  const moveCard = (
    dragIndex: number,
    hoverIndex: number,
    dragRank: number,
    hoverRank: number,
    isDragging: boolean
  ) => {
    console.log(dragIndex, hoverIndex, dragRank, hoverRank, isDragging);
  };

  const fetchSegmentVersion = async (id) => {
    try {
      const res = await callApi(`v1/job/${id}/version-list`, "post", {});
      if (res && res?.status === "Success") {
        let copyObject = {};
        let copyDocuments = res.data?.documents;
        copyDocuments.forEach((objectItem) => {
          copyObject[objectItem.original_id] = objectItem;
        });
        setSegmentVersion(copyObject);
      }
    } catch (e) {}
  };
  const fetchVersionList = async (id) => {
    try {
      const res = await callApi(`v1/job/${id}/version-list-job`, "get", {});
      if (res && res?.status === "Success") {
        setVersion(res.data?.copies);
      }
    } catch (e) {
      showNotification("Error occured", "error");
    }
  };
  const getSegmentData = (item) => {
    return item.segment_id &&
      segmentData &&
      segmentData[item.segment_id] &&
      segmentData[item.segment_id].data
      ? {
          ...segmentData[item.segment_id].data,
          segment_type: item.segment_type,
        }
      : null;
  };

  const getVersionCopyData = (item) => {
    return item.segment_id && segmentVersion[item.segment_id]
      ? {
          ...segmentVersion[item.segment_id],
          segment_type: item.segment_type,
        }
      : null;
  };

  const hasEditMode = () => {
    const segmentEditMode = pageView?.page_order?.some((item) => {
      const versionData = getVersionCopyData(item);
      return versionData?.is_version_copy || versionData?.is_edit;
    });
    const jobEditMode = pageView?.is_edit;

    return segmentEditMode || jobEditMode;
  };

  const hasApproved = () => {
    return !pageView?.is_approved;
  };

  const hasVersionCopyOrEdit = () => {
    return (
      pageView?.is_edit ||
      pageView?.page_order?.some((item) => {
        const data = getVersionCopyData(item);
        return data?.is_edit || data?.is_version_copy;
      })
    );
  };

  const shouldShowPublish = () => {
    const approved = !hasApproved();
    const isPublished = pageView?.is_published;

    if (approved && !isPublished) {
      return true;
    }

    if (approved && isPublished && hasVersionCopyOrEdit()) {
      return true;
    }

    return false;
  };

  const showError = (keyName) => {
    return errors && errors[keyName] ? (
      <p className="text-red-500 text-[14px]  pt-2">{errors[keyName]}</p>
    ) : null;
  };

  return (
    <>
      <div className="flex justify-between mt-2">
        <BreadCrumb
          title={JOB_UPDATE_ROUTE.replace(":id", id)}
          pageTitle={JOB_LIST_ROUTE}
          version="v1"
        />
        <div>
          {userHasPermissionToApprovePage() &&
            !showApprove &&
            hasEditMode &&
            hasApproved() && (
              <div
                className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                onClick={handleApprove}
              >
                Approve
              </div>
            )}
          {userHasPermissionToPublishPage() && shouldShowPublish() && (
            <button
              type="button"
              className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
              onClick={() => {
                handlePublish(jobData?.url);
              }}
            >
              <span className="align-middle">Publish</span>
            </button>
          )}
          <button
            type="button"
            className="ml-2 text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
            onClick={() => toggleMeta()}
          >
            <span className="align-middle">Edit Meta</span>
          </button>
        </div>
      </div>
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                validation.handleSubmit();
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <CustomInput
                    label="Name"
                    name="name"
                    type="text"
                    value={validation.values.name}
                    placeholder="Enter Job Name"
                    onChange={validation.handleChange}
                    isVersioned={version?.name ? true : false}
                    versionedValue={version?.name}
                  />

                  {validation.touched.name && validation.errors.name ? (
                    <p className="text-red-400">{validation.errors.name}</p>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="locationInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Location
                  </label>

                  <ReactSelect
                    options={locationList}
                    contentType={staticLocation}
                    name={"location"}
                    handleContentChange={handleChangeJob}
                    id={"loc23"}
                    isMulti={false}
                    placeholder={"Please select job location"}
                    isSearchable={false}
                    versionData={{
                      label: version?.location,
                      value: version?.location,
                    }}
                  />
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="locationInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Experience
                  </label>

                  <ReactSelect
                    options={experienceList}
                    contentType={staticExperience}
                    name={"experience"}
                    handleContentChange={handleChangeJob}
                    id={"loc23"}
                    isMulti={false}
                    placeholder={"Please select job location"}
                    isSearchable={false}
                    versionData={{
                      label: version?.experience,
                      value: version?.experience,
                    }}
                  />
                </div>
                <div className="xl:col-span-12">
                  <label
                    htmlFor="locationInput"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Division
                  </label>

                  <ReactSelect
                    options={divisionList}
                    contentType={staticDivision}
                    name={"division"}
                    handleContentChange={handleChangeJob}
                    id={"loc23"}
                    isMulti={false}
                    placeholder={"Please select job location"}
                    isSearchable={false}
                    versionData={{
                      label: version?.division,
                      value: version?.division,
                    }}
                  />
                </div>
                <div className="xl:col-span-12" style={{display: "none"}}>

                  <CustomTextArea
                    name="description"
                    value={validation.values.description}
                    label={"Description"}

                
                    placeholder="Enter Description"
                    onChange={(value) =>
                      validation.setFieldValue("description", value)
                    }
                    isVersioned={version?.description ? true : false}
                    versionedValue={version?.description}
                  />

                  {validation.touched.description &&
                  validation.errors.description ? (
                    <p className="text-red-400">
                      {validation.errors.description}
                    </p>
                  ) : null}
                </div>
                <div className="xl:col-span-12">
                  <CustomInput
                    label="Link"
                    name="link"
                    type="text"
                    value={link}
                    placeholder="Enter Link"
                    onChange={(e) => setLink(e.target.value)}
                    isVersioned={version?.link ? true : false}
                    versionedValue={version?.link}
                  />
                  {/* 
                  {validation.touched.link && validation.errors.link ? (
                    <p className="text-red-400">{validation.errors.link}</p>
                  ) : null} */}
                </div>
                <div className="xl:col-span-12">
                  <CustomDateInput
                    value={
                      formData?.released_at
                        ? moment(new Date(formData?.released_at)).toISOString()
                        : ""
                    } // Default to empty string if undefined
                    dateOptions={{ dateFormat: "Y-m-d" }}
                    isRequired={true}
                    keyName="released_at"
                    label="Release Date"
                    setDate={(selectedDates) => {
                      if (selectedDates && selectedDates[0]) {
                        setFormData((prev) => ({
                          ...prev,
                          released_at: selectedDates[0].toISOString(),
                        }));
                      }
                    }}
                    isVersioned={!!version?.released_at} // Only true if version.released_at is defined
                    versionedValue={
                      version?.released_at
                        ? moment(new Date(version?.released_at)).toISOString()
                        : ""
                    } // Default empty string if not defined
                    placeholder="Select Date"
                    errors={""}
                  />
                </div>

                {/* <div
                  onClick={() => {
                    handleAddSegment();
                  }}
                  className="w-[200px] mb-2 text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {"Add Segment"}
                </div> */}
              </div>
              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(JOB_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  id="addNew"
                  disabled={isLoading}
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {isLoading ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Update Jobs"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {pageView?.page_order?.map((item, index) => (
        <EditableView
          moveCard={moveCard}
          pageType={"job"}
          key={index}
          loader={loader}
          setLoader={setLoader}
          index={index}
          pageId={id}
          collapse={collapse}
          handleshowSagment={() => handleshowSagment(index)}
          segmentType={item.segment_type}
          segment_id={item.segment_id}
          data={getSegmentData(item)}
          versionData={getVersionCopyData(item)}
          handleDelete={handleDelete}
          isEditable={userHasPermissionToEditPage()}
        />
      ))}
      <div className="grid grid-cols-12 my-2 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-4 ">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => e.preventDefault()}
            >
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-3">
                  <select
                    value={selectedSegment}
                    onChange={handleSegmentChange}
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                  >
                    <option value="">Select Segment</option>
                    {segmentList?.map((item) => (
                      <option key={item} value={item}>
                        {_.startCase(item)}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
              <div className="mt-6">
                {/* {segments?.map((segment, index) => (
                      <div key={index} className="mt-6 segment-container">
                        <button className="px-4 py-2 mt-4 text-white bg-red-500 rounded">
                          Delete
                        </button>
                      </div>
                    ))} */}
              </div>
              <button
                type="button"
                onClick={handleAddSegment}
                className="px-4 py-2 mt-4 text-white bg-blue-500 rounded"
              >
                Add Segment
              </button>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showMeta}
        onHide={toggleMeta}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Edit"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <MetaData
            handleMetaChange={handleMetaChange}
            modelName="job"
            metaEdit={metaEdit}
            showError={showError}
            toggleMeta={toggleMeta}
            handleMetaData={handleMetaData}
            loader={loader}
          />
        </Drawer.Body>
      </Drawer>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default Updatejob;
